import React, { useEffect } from 'react';
import Table from '@awp/components/table';
import { sortByNumericThenAlpha } from '@awp/helpers/sorter';
import { FORM_MODE, Permissions } from '@awp/constants';
import Authorize from '@awp/components/Authorize';
import { Form } from 'react-bootstrap';
import { isValueEmpty } from '@awp/helpers/utilsReact';
import { ActionMenuEdit, ActionMenuView } from '@awp/components/Common/AwpActionMenus';
import { Link } from 'react-router-dom';
import { useUrlParamTableFilterContext } from '@providers/UrlParamTableFilterContext';
import { AwpContainer } from '@components/Common/AwpContainer';
import { Crud } from '@awp/shared/Crud';
import { StandardGraphAxisService } from '@components/StandardGraphAxis/StandardGraphAxisService';

const StandardGraphAxisTable = ({ data, loading, filteredData, setFilteredData }) => {
  const { defaultPageSize, index, onChangeIndex, onChangePageSize, onChangeSearch, onChangeSort, search, sort } =
    useUrlParamTableFilterContext();

  const crudService = new StandardGraphAxisService(FORM_MODE.LIST);

  const hasSearch = (src) => {
    return src ? src.toLowerCase().includes(search.toLowerCase()) : false;
  };

  useEffect(() => {
    if (!data || data.length === 0) return;
    let filtered = [...data];

    if (!isValueEmpty(search)) {
      filtered = filtered.filter((f) => hasSearch(f.Name));
    }

    setFilteredData(filtered);
  }, [data, search]);

  const columns = React.useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'Name',
        sortType: sortByNumericThenAlpha,
        Cell: (c) => {
          return <div className="text-wrap">{c.value}</div>;
        },
      },
      {
        Header: 'Unit',
        accessor: 'UnitName',
        sortType: sortByNumericThenAlpha,
        Cell: (c) => {
          return <div className="text-wrap">{c.value}</div>;
        },
      },
      {
        Header: 'Min Scale-Max Scale',
        sortType: sortByNumericThenAlpha,
        Cell: (props) => {
          const row = props.row.original;
          const isMinimumScaleFlexible = row.IsMinimumScaleFlexible === 'Y' ? '*' : '';
          const isMaximumScaleFlexible = row.IsMaximumScaleFlexible === 'Y' ? '*' : '';

          return (
            <div className="text-wrap">{`${row.MinimumScaleValue ?? ''}${isMinimumScaleFlexible}-${
              row.MaximumScaleValue ?? ''
            }${isMaximumScaleFlexible}`}</div>
          );
        },
      },
      {
        Header: 'Tick Decimal',
        accessor: 'TickDecimalPlaces',
        sortType: sortByNumericThenAlpha,
        Cell: (c) => {
          return <div className="text-wrap">{c.value}</div>;
        },
      },
      {
        Header: 'Actions',
        accessor: 'Id',
        disableSortBy: true,
        Cell: getActionMenu,
      },
    ],
    [],
  );

  return (
    <AwpContainer>
      <Authorize requires={[Permissions.ReadInventory]}>
        <>
          <div className="container mb-3">
            <div className="row">
              <div className="col-sm-8 pl-0">{crudService.crud.getHeader()}</div>
            </div>
            <div className="container mb-3">
              <div className="row">
                <div className="col-sm-3">
                  <Form.Label>
                    <b>{'Search'}</b>
                  </Form.Label>
                  <input
                    className="form-control  float-left"
                    placeholder="Search..."
                    id="user_text_search"
                    name="search"
                    type="text"
                    value={search}
                    onChange={onChangeSearch}
                  ></input>
                </div>
              </div>
            </div>
          </div>
          <Table
            columns={columns}
            data={filteredData}
            fetchData={() => {}}
            loading={loading}
            defaultSortBy="Name"
            index={index}
            setIndex={onChangeIndex}
            defaultPageSize={defaultPageSize}
            setDefaultPageSize={onChangePageSize}
            sort={sort}
            setSort={onChangeSort}
          />
          <div className="container mb-3" style={{ paddingTop: '1.25rem' }}>
            <div className="row">
              <div className="col-md-12 col-lg-12 col-sm-12 pr-0 pl-0">
                <Authorize requires={[Permissions.WriteAdminTools]}>
                  <Link
                    to={`${FORM_MODE.CREATE}`}
                    className="mr-2 mr-mini-0 float-left btn btn-primary"
                    variant="primary"
                  >
                    Create
                  </Link>
                </Authorize>
              </div>
            </div>
          </div>
        </>
      </Authorize>
    </AwpContainer>
  );
};

function getActionMenu(row) {
  return (
    <>
      <div>
        <Authorize requires={[Permissions.WriteAdminTools]}>
          <Link to={`${FORM_MODE.EDIT}/${row.row.original.Id}`}>
            <ActionMenuEdit />
          </Link>
        </Authorize>
        <Link to={`${FORM_MODE.VIEW}/${row.row.original.Id}`}>
          <ActionMenuView />
        </Link>
      </div>
    </>
  );
}

export default StandardGraphAxisTable;
